import { FC, useEffect, useState } from 'react';
import Swal from 'sweetalert2';
import { useTranslation } from 'react-i18next';
import {
    Grid,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Tooltip,
    IconButton,
    Menu,
    Autocomplete,
    Box,
} from '@mui/material';
import { StoreReturnCommand } from '../../services/command';
import { SCUIContent } from '../../atomic/organisms';
import { SCUIBreadCrumb, SCUICustomDataGrid, SCUIGeneralDrawer } from '../../atomic/molecules';
import { SCUIButton, SCUINoRecordComponent } from '../../atomic/atoms';
import { StoreReturnQuery } from '../../services/query';
import TextField from '@mui/material/TextField';
import { ExtendedGridColDef } from '@/types/ExtendedGridColDef';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { SCUICustomerDrawerContent } from './components/SCUICustomerDrawerContent';
import PopupState, { bindTrigger, bindMenu } from 'material-ui-popup-state';
import { SCUICustomerDecisionDrawerContent } from './components/SCUICustomerDecisionDrawerContent';
import TimeHelper from '../../utils/time';
import { SCS } from './storeCustomerService.classes';

export const StoreCustomerService: FC<any> = () => {
    const { t } = useTranslation();
    const [cepTel, setCepTel] = useState<any>(null);
    const [warehouse, setWarehouse] = useState<any>([]);
    const [returnId, setReturnId] = useState<any>(null);
    const [datas, setDatas] = useState<any>([]);
    const [warehouseId, setWarehouseId] = useState<any>(null);
    const [type, setType] = useState('1');
    const [customer, setCustomer] = useState<any>([]);
    const [state, setState] = useState({
        right: false,
    });
    const [stateDecision, setStateDecision] = useState({
        right: false,
    });
    const onDrawerOpen = () => setState({ ...state, right: true });
    const onDrawerClose = () => setState({ ...state, right: false });
    const onDrawerOpenDecision = () => setStateDecision({ ...stateDecision, right: true });
    const onDrawerCloseDecision = () => setStateDecision({ ...stateDecision, right: false });

    const handleChange = (event: any) => {
        if ((event.target.value as string) === '1') {
            setCepTel(null);
        } else {
            setReturnId(null);
            setWarehouseId(null);
        }
        setType(event.target.value as string);
    };
    const columns: ExtendedGridColDef[] = [
        {
            field: 'magazaKod',
            headerName: 'Kod',
            width: 70,
            renderCell: (params: any) => {
                return (
                    <div className={SCS.cellStoreCode} data-store-code={params.row.magazaKod}>
                        <Tooltip title={<h2>{params.row.magazaKod}</h2>}>
                            <p className={SCS.cellStoreCodeText}>{params.row.magazaKod}</p>
                        </Tooltip>
                    </div>
                );
            },
        },
        {
            field: 'magazaAd',
            headerName: 'Mağaza Ad',
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params: any) => (
                <span className={SCS.cellStoreName} data-store-name={params.row.magazaAd}>
                    {params.row.magazaAd}
                </span>
            ),
        },
        {
            field: 'iadeKayitNo',
            headerName: 'İade Kayıt No',
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params: any) => (
                <span className={SCS.cellReturnId} data-return-id={params.row.iadeKayitNo}>
                    {params.row.iadeKayitNo}
                </span>
            ),
        },
        {
            field: 'tarih',
            headerName: 'Kayıt Tarihi',
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params: any) => (
                <span className={SCS.cellDate} data-date={params.row.tarih}>
                    {params.row.tarih}
                </span>
            ),
        },
        {
            field: 'ad',
            headerName: 'Müşteri Adı',
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params: any) => (
                <span className={SCS.cellCustomerName} data-customer-name={params.row.ad}>
                    {params.row.ad}
                </span>
            ),
        },
        {
            field: 'cepTel',
            headerName: 'Telefon',
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params: any) => (
                <span className={SCS.cellPhone} data-phone={params.row.cepTel}>
                    {params.row.cepTel}
                </span>
            ),
        },

        {
            field: 'iadeSikayetKonusu',
            headerName: 'İade Şikayet Konusu',
            flex: 1,
            headerAlign: 'center',
            align: 'left',
            renderCell: (params: any) => {
                return (
                    <div className={SCS.cellComplaint} data-complaint={params.row.iadeSikayetKonusu}>
                        <Tooltip title={<h2>{params.row.iadeSikayetKonusu}</h2>}>
                            <p className={SCS.cellComplaintText}>{params.row.iadeSikayetKonusu}</p>
                        </Tooltip>
                    </div>
                );
            },
        },
        {
            field: 'musteriNo',
            headerName: 'Müşteri No',
            flex: 1,
            hide: true,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params: any) => (
                <span className={SCS.cellCustomerNo} data-customer-no={params.row.musteriNo}>
                    {params.row.musteriNo}
                </span>
            ),
        },
        {
            field: 'detay',
            headerName: 'Detay',
            flex: 1,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params: any) => {
                const handleClick = (popupState: any, tur: string) => {
                    popupState.close();
                    switch (tur) {
                        case 'detail': {
                            setCustomer(params.row);
                            onDrawerOpen();
                            break;
                        }
                        case 'decision': {
                            setCustomer(params.row);
                            onDrawerOpenDecision();
                            break;
                        }

                        default: {
                            break;
                        }
                    }
                };
                return (
                    <PopupState variant="popover" popupId="demo-popup-menu">
                        {(popupState: any) => (
                            <div className={SCS.cellActions}>
                                <IconButton
                                    {...bindTrigger(popupState)}
                                    className={SCS.btnRowMenu}
                                    data-return-id={params.row.iadeKayitNo}
                                    data-store-code={params.row.magazaKod}
                                >
                                    {' '}
                                    <MoreVertIcon className="svg_icons" />{' '}
                                </IconButton>
                                <Menu {...bindMenu(popupState)} className={SCS.rowMenu}>
                                    <MenuItem
                                        onClick={() => handleClick(popupState, 'detail')}
                                        className={`${SCS.rowMenuItem} ${SCS.rowMenuItemDetail}`}
                                        data-action="detail"
                                    >
                                        {'Detay Görüntüle'}{' '}
                                    </MenuItem>
                                    <MenuItem
                                        onClick={() => handleClick(popupState, 'decision')}
                                        className={`${SCS.rowMenuItem} ${SCS.rowMenuItemDecision}`}
                                        data-action="decision"
                                    >
                                        {'Karar Görüntüle'}{' '}
                                    </MenuItem>
                                </Menu>
                            </div>
                        )}
                    </PopupState>
                );
            },
        },
    ];
    const GetWarehouses = async () => {
        StoreReturnQuery.GetWarehouses()
            .then((res: any) => {
                //    Swal.fire(res, " ", "success");
                setWarehouse(res.data);
            })
            .catch((error: any) => {
                Swal.fire(t('general.error'), ' ', 'error');
                console.log('Hata :>> ', error);
            })
            .finally(() => {});
    };
    useEffect(() => {
        GetWarehouses();
    }, []);
    const GetMusteriİade = async () => {
        let params: any = {
            storeCode: warehouseId,
            returnId: returnId,
            cepTel: cepTel,
        };
        StoreReturnCommand.GetMusteriİade(params)
            .then((res: any) => {
                if (res && res.length > 0) {
                    let parseData = res.map((item: any) => {
                        return {
                            magazaKod: item.magazaKod || '',
                            magazaAd: item.magazaAd || '-',
                            iadeKayitNo: item.iadeKayitNo || '-',
                            tarih: TimeHelper.formatDate(item.tarih) || '-',
                            iadeSikayetKonusu: item.iadeSikayetKonusu || '-',
                            musteriNo: item.musteriNo || '-',
                            musteriDepo: item.musteriDepo || '-',
                            ad: item.ad + '  ' + item.soyad || '-',
                            cepTel: item.cepTel || '-',
                            adres: item.adres || '-',
                            ilce: item.ilce || '-',
                            il: item.il || '-',
                            durum: item.durum || '-',
                        };
                    });
                    setDatas(parseData);
                } else {
                    Swal.fire(t('general.noDataFound'), ' ', 'error');
                }
            })
            .catch((error: any) => {
                Swal.fire(t('general.error'), ' ', 'warning');
                console.log('Hata :>> ', error);
            })
            .finally(() => {});
    };
    return (
        <SCUIContent className={SCS.page}>
            <Grid container direction="row" spacing={2} sx={{ marginLeft: '0.5rem' }} className={SCS.root}>
                <Box className={SCS.breadcrumb}>
                    <SCUIBreadCrumb title={t('general.storeProductReview')} componentLink={'storeCustomerService'} />
                </Box>
                {datas.length > 0 ? (
                    <Grid container direction="row" sx={{ marginLeft: '0.5rem' }} className={SCS.results}>
                        <Grid container spacing={1} className={SCS.resultsHeader}>
                            <Grid
                                className={SCS.resultsTitleBox}
                                sx={{ marginRight: '3rem' }}
                                size={{
                                    xl: 7,
                                    lg: 6,
                                    md: 12,
                                    xs: 12,
                                }}
                            >
                                <h1 className={`headtxt ${SCS.resultsTitle}`}>{t('general.searchResults')}</h1>
                            </Grid>
                        </Grid>
                        <Box className={SCS.detailDrawer}>
                            <SCUIGeneralDrawer
                                open={state['right']}
                                anchor="right"
                                width={'60rem'}
                                onClose={(event: any, reason: any) => {
                                    if (reason === 'backdropClick') {
                                        setState({ ...state, right: false });
                                    }
                                }}
                            >
                                <SCUICustomerDrawerContent selectedRow={customer} onCloseMenu={onDrawerClose} />
                            </SCUIGeneralDrawer>
                        </Box>
                        <Box className={SCS.decisionDrawer}>
                            <SCUIGeneralDrawer
                                open={stateDecision['right']}
                                anchor="right"
                                width={'60rem'}
                                onClose={(event: any, reason: any) => {
                                    if (reason === 'backdropClick') {
                                        setStateDecision({ ...stateDecision, right: false });
                                    }
                                }}
                            >
                                <SCUICustomerDecisionDrawerContent
                                    selectedRow={customer}
                                    onCloseMenu={onDrawerCloseDecision}
                                />
                            </SCUIGeneralDrawer>
                        </Box>
                        <Grid
                            className={SCS.grid}
                            sx={{ marginBottom: '1rem' }}
                            size={{
                                xl: 12,
                                lg: 12,
                                md: 12,
                                xs: 12,
                            }}
                        >
                            <SCUICustomDataGrid randomId rows={datas} columns={columns} />
                        </Grid>
                    </Grid>
                ) : (
                    <Grid
                        className={SCS.emptyState}
                        size={{
                            xl: 12,
                            lg: 12,
                            md: 12,
                            xs: 12,
                        }}
                    >
                        <Box className={SCS.emptyNoRecord}>
                            <SCUINoRecordComponent />
                        </Box>
                        <div
                            className={SCS.filterForm}
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignContent: 'center',
                                justifyContent: 'center',
                                alignItems: 'center',
                            }}
                        >
                            <Grid
                                className={SCS.filterFormBody}
                                sx={{ marginBottom: '2rem' }}
                                style={{
                                    display: 'flex',
                                    alignContent: 'center',
                                    flexDirection: 'column',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                }}
                                size={{
                                    sm: 12,
                                    md: 12,
                                    lg: 7,
                                    xl: 7,
                                }}
                            >
                                <FormControl className={SCS.filterType} style={{ width: 450, margin: '20px' }}>
                                    <InputLabel id="demo-simple-select-label">{t('general.operation')}</InputLabel>
                                    <Select
                                        className={SCS.inputType}
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        value={type}
                                        label={t('general.operation')}
                                        onChange={handleChange}
                                        data-type-value={type}
                                    >
                                        <MenuItem
                                            value={'1'}
                                            className={`${SCS.typeMenuItem} ${SCS.typeMenuItemStore}`}
                                            data-type-value="1"
                                        >
                                            {t('general.storeCode')} - {t('general.returnRecordNumber')}
                                        </MenuItem>
                                        <MenuItem
                                            value={'2'}
                                            className={`${SCS.typeMenuItem} ${SCS.typeMenuItemPhone}`}
                                            data-type-value="2"
                                        >
                                            {t('general.phoneNumber')}
                                        </MenuItem>
                                    </Select>
                                </FormControl>
                                {type === '1' && (
                                    <FormControl className={SCS.filterStore} style={{ width: 450, margin: '20px' }}>
                                        <Autocomplete
                                            className={SCS.inputStore}
                                            disablePortal
                                            id="combo-box-demo"
                                            options={warehouse || []}
                                            getOptionLabel={(option) => option.tanim + '-' + option.kod}
                                            renderOption={(props, option) => (
                                                <li
                                                    {...props}
                                                    className={`${(props as any).className || ''} ${SCS.storeOption}`.trim()}
                                                    data-store-code={option?.kod}
                                                    data-store-name={option?.tanim}
                                                >
                                                    {option.tanim + '-' + option.kod}
                                                </li>
                                            )}
                                            onChange={(event: any, newValue: any) => {
                                                setWarehouseId(newValue['kod'].trim());
                                            }}
                                            renderInput={(params) => (
                                                <TextField {...params} label={t('general.storeWarehouse')} />
                                            )}
                                        />
                                    </FormControl>
                                )}
                                {type === '1' && (
                                    <FormControl className={SCS.filterReturnId} style={{ width: 450, margin: '10px' }}>
                                        <TextField
                                            className={SCS.inputReturnId}
                                            id="standard-basic"
                                            label={t('general.returnRecordNumber')}
                                            variant="outlined"
                                            onChange={(event: any) => {
                                                setReturnId(event.target.value);
                                            }}
                                        />
                                    </FormControl>
                                )}

                                {type === '2' && (
                                    <FormControl className={SCS.filterPhone} style={{ width: 450, margin: '10px' }}>
                                        <TextField
                                            className={SCS.inputPhone}
                                            id="standard-basic"
                                            label="Telefon Numarası"
                                            variant="outlined"
                                            onChange={(event: any) => {
                                                setCepTel(event.target.value);
                                            }}
                                        />
                                    </FormControl>
                                )}

                                <FormControl className={SCS.filterAction} style={{ width: 450, margin: '10px' }}>
                                    <SCUIButton
                                        className={SCS.btnFilter}
                                        text={t('general.filter')}
                                        type="primary"
                                        sizeType="default"
                                        size={'l'}
                                        onClick={() => {
                                            GetMusteriİade();
                                        }}
                                    />
                                </FormControl>
                            </Grid>
                        </div>
                    </Grid>
                )}
            </Grid>
        </SCUIContent>
    );
};
